"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldSkipPdpLinkQuery = void 0;
var _net = require("../models/graphql-types/net");
const shouldSkipPdpLinkQuery = ({
  loadingHeaders,
  type,
  productCode
}) => productCode == null || productCode === '' || loadingHeaders || type !== _net.FeedbackBenefitBannerType.ShareAndEarn;
exports.shouldSkipPdpLinkQuery = shouldSkipPdpLinkQuery;
